(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["course-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonial-pager')) {
    customElements.define(
      'testimonial-pager',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          if (!this.track) return;
          this.cards = [...this.track.querySelectorAll('.ctw__card')];
          this.nav = this.querySelector('[data-nav]');
          this.footer = this.querySelector('[data-footer]');
          this.dotsEl = this.querySelector('[data-dots]');
          this.counter = this.querySelector('[data-counter]');
          this.prev = this.querySelector('[data-prev]');
          this.next = this.querySelector('[data-next]');
          this.mq = window.matchMedia('(min-width: 750px)');

          this.prev.addEventListener('click', () => this.go(this.index() - 1));
          this.next.addEventListener('click', () => this.go(this.index() + 1));
          this.onScroll = () => {
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => this.update());
          };
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.onChange = () => this.build();
          this.mq.addEventListener('change', this.onChange);
          this.build();
        }

        disconnectedCallback() {
          if (this.mq) this.mq.removeEventListener('change', this.onChange);
        }

        perPage() {
          return this.mq.matches ? 6 : 3;
        }

        build() {
          // Put every card back in the track, drop old pages
          this.cards.forEach((c) => this.track.appendChild(c));
          this.track.querySelectorAll('.ctw__page').forEach((p) => p.remove());

          const per = this.perPage();
          this.paged = this.cards.length > per;
          this.track.classList.toggle('is-paged', this.paged);
          this.nav.hidden = !this.paged;
          this.footer.hidden = !this.paged;
          this.pages = [];
          if (!this.paged) return;

          for (let i = 0; i < this.cards.length; i += per) {
            const page = document.createElement('div');
            page.className = 'ctw__page';
            this.cards.slice(i, i + per).forEach((c) => page.appendChild(c));
            this.track.appendChild(page);
            this.pages.push(page);
          }

          this.dotsEl.innerHTML = '';
          this.pages.forEach((_, k) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'ctw__dot';
            b.setAttribute('aria-label', '第 ' + (k + 1) + ' 頁');
            b.appendChild(document.createElement('span'));
            b.addEventListener('click', () => this.go(k));
            this.dotsEl.appendChild(b);
          });

          this.track.scrollLeft = 0;
          this.update();
        }

        step() {
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          return this.track.clientWidth + gap;
        }

        index() {
          if (!this.paged) return 0;
          return Math.max(0, Math.min(this.pages.length - 1, Math.round(this.track.scrollLeft / this.step())));
        }

        go(i) {
          const target = Math.max(0, Math.min(this.pages.length - 1, i));
          this.track.scrollTo({ left: target * this.step(), behavior: 'smooth' });
        }

        update() {
          if (!this.paged) return;
          const i = this.index();
          const last = this.pages.length - 1;
          this.prev.disabled = i <= 0;
          this.next.disabled = i >= last;
          [...this.dotsEl.children].forEach((d, k) => d.classList.toggle('is-active', k === i));
          const pad = (n) => (this.mq.matches ? String(n) : String(n).padStart(2, '0'));
          this.counter.textContent = pad(i + 1) + ' / ' + pad(this.pages.length);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
